import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { getAllProductChannels } from "store/channels/actions"
import { updateJackpot } from "store/jackpots/actions"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { Link } from "react-router-dom"

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import React, { useEffect, useState } from "react"
import Select from "react-select"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import MetaTags from "react-meta-tags"
import {
  Table,
  InputGroup,
  CardTitle,
  CardSubtitle,
  UncontrolledTooltip,
  Button,
  Card,
  Input,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import {
  dateIsBetween,
  formValidation,
  mapDataForDropDown,
  showErrorMessages,
} from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import {getAllJackpotsCall, getAllEventsCall, getAllSportsCall, getFixtureBySportIdCall} from "helpers/repository"
import { getAllEvents } from "store/events/actions"
import moment from "moment";
import Loader from "../../../helpers/loader";
import {sitename} from "../../../constants/constants";
import {get} from "lodash"
import MessageBox from "../../../components/Common/MessageBox"
const Edit = props => {
  const outerData = [];
  const outerDataSelected = [];
  const Channels = useSelector(state => state.productChannels.Index ?? [])
  const Events = useSelector(state => state.events.Index ?? [])

  const dispatch = useDispatch()
  const [name, set_name] = useState("")
  const [description, set_description] = useState("")
  const [market, set_market] = useState("")
  const [is_active, set_is_active] = useState("")
  const [price_per_ticket, set_price_per_ticket] = useState("")
  const [max_price, set_max_price] = useState("")
  const [n_1, set_n_1] = useState("")
  const [n_2, set_n_2] = useState("")
  const [channels, set_channels] = useState([])
  const [events, set_events] = useState([])
  const [selected_events, set_selected_events] = useState([])
  const [sportId, setSportId] = useState(null);
  const [fixtures, setFixtureData] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [next_page_url, set_next_page_url] = useState(null);
  const [loadMoreMessage, setLoadMoreMessage] = useState("Load More Data");
  const [selectedDates, setSelectedDates] = useState([moment().add(1, 'days').format("YYYY-MM-DD"),moment().add(1, 'days').format("YYYY-MM-DD")])
  const [stateData, setState] = useState(false);
  const urlParams = new URLSearchParams(props.location.search)
  const [trigger, setTrigger] = useState(0);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    dispatch(apiError(""))
    dispatch(getAllProductChannels())
    dispatch(getAllEvents())
    setSelectedDates([moment().add(1, 'days').format("YYYY-MM-DD"),moment().add(1, 'days').format("YYYY-MM-DD")])

    getAllJackpotsCall().then(res => {
      let obj = res.data.data.filter(bn => bn["id"] == urlParams.get("id"))
      obj = obj.length > 0 ? obj[0] : {}
      let allLeagues = obj.fixtures?.map((f) => f?.tournament?.bb_id);
      allLeagues = [...new Set(allLeagues)];
      getData(moment().add(1, 'days').format("YYYY-MM-DD"),moment().add(1, 'days').format("YYYY-MM-DD"),obj?.market)
      allLeagues?.map((league, index) => {
        obj.fixtures
            .filter((f) => f.tournament_bb_id == league)
            .map((fixture) => {
              const innerData={};
              innerData['id']=fixture.bb_id;
              innerData['team_1']=fixture.competitors[0]?.name;
              innerData['team_2']=fixture.competitors[1]?.name;
              innerData['date']=new Date(parseInt(fixture.match_date.$date.$numberLong)).toLocaleString('en-GB')
              outerDataSelected.push(innerData);
            })
      })
      set_selected_events(outerDataSelected);

      // getAllEventsCall().then(res => {
      //   const myDifferences = _.differenceBy(res.data.data, obj.events, "id")
      //   set_events(myDifferences)
      //   set_selected_events(obj.events)
      // })

      let sl_events = [...obj.fixtures]
      sl_events.forEach(function (v) {
        delete v.pivot
      })

      set_name(obj.name)
      set_description(obj.description)
      set_market(obj.market)
      set_is_active(obj.is_active)
      set_price_per_ticket(obj.price_per_ticket)
      set_max_price(obj.max_price)
      set_n_1(obj.n_1)
      set_n_2(obj.n_2)
      set_channels(mapDataForDropDown(obj.channels))

    })

  }, [])

  useEffect(() => {
    if(fixtures){
      for (let i = fixtures.length - 1; i >= 0; i--) {
        let odds = fixtures[i]?.fixture_markets[0]?.fixture_market_odds_active ?? [];
        if (odds.length === 0) {
          fixtures.splice(i, 1);
        }
      }
      let allLeagues = fixtures?.map((f) => f?.tournament?.bb_id);
      allLeagues = [...new Set(allLeagues)];
      setLeagues(allLeagues);
    }
  }, [fixtures]);

  useEffect(() => {
    if(leagues){
      leagues?.map((league, index) => {
        // console.log(selected_events,fixtures)
        const myDifferences = _.differenceWith(fixtures, selected_events, ({ bb_id }, { id }) => _.eq(bb_id, id))

        myDifferences
            .filter((f) => f.tournament_bb_id == league)
            .map((fixture) => {
              const innerData={};
              innerData['id']=fixture.bb_id;
              innerData['team_1']=fixture.competitors[0]?.name;
              innerData['team_2']=fixture.competitors[1]?.name;
              innerData['date']=new Date(parseInt(fixture.match_date.$date.$numberLong)).toLocaleString('en-GB')
              outerData.push(innerData);
            })
      })
      set_events(outerData);

    }
  }, [leagues]);

  const getData = (date1,date2,marketVal=null) => {
    setState(true);
    getAllSportsCall().then(res => {
      setLoadMoreMessage("Loading Data...");
      const sports=res.data.data.data
      if(sports){
        setSportId(sports?.find((s) => s.name == "Soccer")?.id);
        const sporsID=sports?.find((s) => s.name == "Soccer")?.id;
        var marketData=marketVal==null?market:marketVal;
        getFixtureBySportIdCall(next_page_url,sporsID,date1,date2,marketData,searchValue)
            .then((res) => {
              let unique_fixtures = [];
              if(!searchValue){
                let new_fixtures = get(res, "data.data.data", []);
                let combined_fixtures = fixtures.concat(new_fixtures);

                unique_fixtures = combined_fixtures.filter((v,i,a)=>a.findIndex(t=>(t._id===v._id))===i)

              }
              else{
                unique_fixtures = get(res, "data.data.data", []);
              }



              const myDifferences = _.differenceWith(unique_fixtures, selected_events, ({ bb_id }, { id }) => _.eq(bb_id, id))
              setFixtureData(myDifferences);
              set_next_page_url(res.data.data.next_page_url);
              setState(false);
            }).finally(() => {
          setLoadMoreMessage("Load More Data");
        });
      }
    })
  }

  useEffect(() => {
    getData(selectedDates[0],selectedDates[1],market);
  }, [trigger]);
  const formErrors = useSelector(state => state?.CommonState)

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      name: name,
      description: description,
      market: market,
      price_per_ticket: price_per_ticket,
      max_price: max_price,
      is_active: is_active,
      n_1: n_1,
      n_2: n_2,
      // is_active,
      product_channel_id: channels.map(item => item.id),
      event_id: selected_events.map(se => se.id),
      id: urlParams.get("id"),
    }
    if (data.event_id.length == 0) {
      toastr.error("Please Select an Event")
    }
    dispatch(updateJackpot(data, props.history))
  }
  const handleSearchEnterKey = (event) => {
    if (event.key === 'Enter') {
      // Prevent the default Enter behavior (form submission)
      event.preventDefault();
      // Make your API call here using the searchText
      getData(selectedDates[0],selectedDates[1],market);
    }
  }

  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }

  const availableColumns = [
    {
      dataField: "team_1",
      text: "Name",
      sort: true,
      style: { whiteSpace: "break-spaces" },
      formatter: (cellContent, row) => (
          <>
            <p className="mb-1 fw-bold">{`${row.date} ${row.team_1} vs ${row.team_2}`}</p>
          </>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      headerStyle: (colum, colIndex) => {
        return { width: "50px" }
      },
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <>
            <div className="d-flex gap-3">
              <i
                  className="mdi mdi-plus-circle font-size-18 text-danger icon"
                  id="addtooltip"
                  onClick={() => {
                    set_events(evts => evts.filter(ev => ev.id !== row.id))
                    set_selected_events(evts => [...evts, row])
                  }}
              />
              <UncontrolledTooltip placement="top" target="addtooltip">
                Add
              </UncontrolledTooltip>
            </div>
          </>
      ),
    },
  ]
  const selectedColumns = [
    {
      dataField: "team_1",
      text: "Name",
      sort: true,
      style: { whiteSpace: "break-spaces" },
      formatter: (cellContent, row) => (
          <>
            <p className="mb-1 fw-bold">{`${row.date} ${row.team_1} vs ${row.team_2}`}</p>
          </>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "20px" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <>
            <div className="d-flex gap-3 pe-auto">
              <i
                  className="mdi mdi-delete-circle font-size-18 text-danger icon"
                  id="deletetooltip"
                  onClick={() => {
                    set_selected_events(evts => evts.filter(ev => ev.id !== row.id))
                    set_events(evts => [...evts, row])
                  }}
              />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </div>
          </>
      ),
    },
  ]
  const defaultSorted = [
    {
      order: "asc",
    },
  ]

  // Table Data
  const pageOptions = {
    sizePerPage: 10,
    totalSize: Events.length, // replace later with size(customers),
    custom: true,
  }

  const { SearchBar } = Search
  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{sitename}</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Bonuses" breadcrumbItem="Edit" />
            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">
                <i className="bx bx-sort-up"></i> &nbsp; Edit Jackpot Pool
              </h5>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <div className="row mb-4">
                    <div className="col">
                      <label className="form-label">Name</label>
                      <input
                          className="form-control"
                          type="text"
                          onChange={e => {
                            removeError("name")
                            set_name(e.target.value)
                          }}
                          value={name}
                      />
                      {formErrors?.name ? (
                          <FieldValidation errorMessage={formErrors?.name} />
                      ) : null}
                    </div>
                    <div className="col">
                      <label className="form-label">Description</label>
                      <input
                          className="form-control"
                          type="text"
                          onChange={e => {
                            removeError("description")
                            set_description(e.target.value)
                          }}
                          value={description}
                      />
                      {formErrors?.description ? (
                          <FieldValidation errorMessage={formErrors?.description} />
                      ) : null}
                    </div>
                    <div className="col">
                      <label className="form-label">Market</label>
                      <Select
                          maxMenuHeight={150}
                          onChange={item => {
                            removeError("market")
                            getData(selectedDates[0],selectedDates[1],item.value);
                            set_market(item.value)
                            set_selected_events([]);
                          }}
                          options={[
                            {
                              value: "1x2",
                              label: "1x2",
                            },
                            {
                              value: "u/0 2.5",
                              label: "u/0 2.5",
                            },
                            {
                              value: "BTTS",
                              label: "BTTS",
                            },
                          ]}
                          classNamePrefix="select2-selection"
                          value={{ label: market, value: market }}
                      />
                      {formErrors?.market ? (
                          <FieldValidation errorMessage={formErrors?.market} />
                      ) : null}
                    </div>
                    <div className="col">
                      <label className="form-label">Channels</label>
                      <Select
                          maxMenuHeight={150}
                          isMulti={true}
                          options={mapDataForDropDown(Channels)}
                          classNamePrefix="select2-selection"
                          onChange={item => {
                            removeError("product_channel_id")
                            set_channels(item)
                          }}
                          value={channels}
                      />
                      {formErrors?.product_channel_id ? (
                          <FieldValidation
                              errorMessage={formErrors?.product_channel_id}
                          />
                      ) : null}
                    </div>
                    <div className="col">
                      <label className="form-label">Query Date</label>
                      <InputGroup>
                        <Flatpickr
                            className="form-control d-block"
                            placeholder="yyyy-dd-mm"
                            options={{
                              mode: "range",
                              dateFormat: "Y-m-d",
                              minDate: "today"
                            }}
                            value={selectedDates}
                            onChange={(date, dateStr, instance) => {
                              if(moment(new Date(date[1])).isValid()){
                                const storeArray=[];
                                storeArray.push(moment(new Date(date[0])).format("YYYY-MM-DD"))
                                storeArray.push(moment(new Date(date[1])).format("YYYY-MM-DD"))
                                setSelectedDates(storeArray)
                                getData(moment(new Date(date[0])).format("YYYY-MM-DD"),moment(new Date(date[1])).format("YYYY-MM-DD"));
                              }
                            }}
                        />
                      </InputGroup>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <Col lg={2}>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Is Active?</label>
                          <div className="row mb-4">
                            <Col lg={12}>
                              <input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="defaultCheck1"
                                  onChange={() => {
                                    removeError("is_active")
                                    set_is_active(!is_active)
                                  }}
                                  checked={is_active}
                              />{" "}
                              <label
                                  className="form-check-label"
                                  htmlFor="defaultCheck1"
                              >
                                activate pool
                              </label>
                              {formErrors?.is_active ? (
                                  <FieldValidation
                                      errorMessage={formErrors?.is_active}
                                  />
                              ) : null}
                            </Col>
                          </div>
                        </Col>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Price</label>
                          <InputGroup>
                            <div className="input-group-text">Per Ticket</div>
                            <input
                                type="text"
                                className="form-control"
                                id="autoSizingInputGroup"
                                onChange={e => {
                                  removeError("price_per_ticket")
                                  set_price_per_ticket(e.target.value)
                                }}
                                value={price_per_ticket}
                            />
                          </InputGroup>
                          {formErrors?.price_per_ticket ? (
                              <FieldValidation
                                  errorMessage={formErrors?.price_per_ticket}
                              />
                          ) : null}
                        </Col>
                      </div>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Prizes (Max)</label>
                          <InputGroup>
                            <div className="input-group-text">5 Hit</div>
                            <input
                                type="text"
                                className="form-control"
                                id="autoSizingInputGroup"
                                onChange={e => {
                                  removeError("max_price")
                                  set_max_price(e.target.value)
                                }}
                                value={max_price}
                            />
                          </InputGroup>
                          {formErrors?.max_price ? (
                              <FieldValidation
                                  errorMessage={formErrors?.max_price}
                              />
                          ) : null}
                        </Col>
                      </div>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Prizes (N - 1)</label>
                          <InputGroup>
                            <div className="input-group-text">5 Hit</div>
                            <input
                                type="text"
                                className="form-control"
                                id="autoSizingInputGroup"
                                onChange={e => {
                                  removeError("n_1")
                                  set_n_1(e.target.value)
                                }}
                                value={n_1}
                            />
                          </InputGroup>
                          {formErrors?.n_1 ? (
                              <FieldValidation errorMessage={formErrors?.n_1} />
                          ) : null}
                        </Col>
                      </div>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Prizes (N - 2)</label>
                          <InputGroup>
                            <div className="input-group-text">5 Hit</div>
                            <input
                                type="text"
                                className="form-control"
                                id="autoSizingInputGroup"
                                onChange={e => {
                                  removeError("n_2")
                                  set_n_2(e.target.value)
                                }}
                                value={n_2}
                            />
                          </InputGroup>
                          {formErrors?.n_2 ? (
                              <FieldValidation errorMessage={formErrors?.n_2} />
                          ) : null}
                        </Col>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Available Events</label>
                          <Card>
                            <CardBody>
                              <div className="mb-2 row">
                                <div className="col-lg-12">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative"><label htmlFor="search-bar-0"
                                                                              className="search-label">
                                      <span id="search-bar-0-label" className="sr-only">Search this table</span>
                                      <input id="search-bar-0"
                                             type="text"
                                             aria-labelledby="search-bar-0-label"
                                             className="form-control "
                                             placeholder="Search"
                                             spellCheck="false"
                                             data-ms-editor="true"
                                             onKeyDown={handleSearchEnterKey}
                                             onChange={(e) => {
                                               setSearchValue(e.target.value);
                                             }}/>
                                    </label>
                                      <i className="bx bx-search-alt search-icon"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {stateData ? <Loader /> :
                                  <ToolkitProvider
                                      keyField="id"
                                      columns={availableColumns}
                                      data={events}
                                      // search
                                  >
                                    {toolkitProps => (
                                        <React.Fragment>
                                          {/*<Row className="mb-2">*/}
                                          {/*  <Col lg="12">*/}
                                          {/*    <div className="search-box me-2 mb-2 d-inline-block">*/}
                                          {/*      <div className="position-relative">*/}
                                          {/*        <SearchBar*/}
                                          {/*            {...toolkitProps.searchProps}*/}
                                          {/*        />*/}
                                          {/*        <i className="bx bx-search-alt search-icon" />*/}
                                          {/*      </div>*/}
                                          {/*    </div>*/}
                                          {/*  </Col>*/}
                                          {/*</Row>*/}

                                          <Row>
                                            <Col xl="12">
                                              <div
                                                  className="table-responsive"
                                                  style={{
                                                    height: 400,
                                                    overflowY: "auto",
                                                  }}
                                              >
                                                <BootstrapTable
                                                    keyField={"id"}
                                                    responsive
                                                    bordered={false}
                                                    striped={false}
                                                    defaultSorted={defaultSorted}
                                                    classes={
                                                      "table align-middle table-nowrap"
                                                    }
                                                    headerWrapperClasses={"thead-light"}
                                                    {...toolkitProps.baseProps}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </React.Fragment>
                                    )}
                                  </ToolkitProvider>
                              }

                            </CardBody>
                          </Card>
                          <CardBody>
                            {next_page_url && (
                                <div
                                    onClick={() => {
                                      setTrigger(trigger + 1);
                                    }}
                                >
                                  <MessageBox data={loadMoreMessage} />
                                </div>
                            )}
                          </CardBody>
                        </Col>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="row mb-4">
                        <Col lg={12}>
                          <label className="form-label">Selected Events</label>
                          <Card>
                            <CardBody>
                              <ToolkitProvider
                                  keyField="id"
                                  columns={selectedColumns}
                                  data={selected_events}
                                  search
                              >
                                {toolkitProps => (
                                    <React.Fragment>
                                      <Row className="mb-2">
                                        <Col lg="12">
                                          <div className="search-box me-2 mb-2 d-inline-block">
                                            <div className="position-relative">
                                              <SearchBar
                                                  {...toolkitProps.searchProps}
                                              />
                                              <i className="bx bx-search-alt search-icon" />
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col xl="12">
                                          <div
                                              className="table-responsive"
                                              style={{
                                                height: 400,
                                                overflowY: "auto",
                                              }}
                                          >
                                            <BootstrapTable
                                                keyField={"id"}
                                                responsive
                                                bordered={false}
                                                striped={false}
                                                defaultSorted={defaultSorted}
                                                classes={
                                                  "table align-middle table-nowrap"
                                                }
                                                headerWrapperClasses={"thead-light"}
                                                {...toolkitProps.baseProps}
                                            />
                                          </div>
                                        </Col>
                                      </Row>
                                    </React.Fragment>
                                )}
                              </ToolkitProvider>
                            </CardBody>
                          </Card>
                        </Col>
                      </div>
                    </Col>
                  </div>

                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <Button type="submit" color="primary">
                      Save
                    </Button>
                    <Button
                        type="reset"
                        color="secondary"
                        className=""
                        onClick={() => {
                          props.history.push("/promotions/jackpots")
                        }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
  )
}
export const EditJackpot = withRouter(Edit)
